import { Gender, genderTitles, type SubmitBuyerPassenger } from '@store/form';
import { type InvoiceEntry } from '@store/invoice';
import {
    ReserveSeatApiApiReserveSeatV2Post,
    type SeatStatus,
} from '@clients/BusApi';
import BillHandler from '@itinerary/BillHandler';
import { ReserveType } from '@utils/itinerary';
import { type PaxType } from '@utils/types';
import { type BusSummary } from '@composable/useBusSeatHandler';

export default class BusBillHandler extends BillHandler {
    constructor(
        public reserveId: number,
        public busId: number,
        public isExclusive: boolean
    ) {
        super();
        this.concreteType = ReserveType.Bus;
    }

    override async registerPaxInfo(params: {
        pax: SubmitBuyerPassenger[];
        email: string;
        mobile: string;
        destinationMobile: string;
        billId: number;
        customData: any;
        billCode: string;
        entries: InvoiceEntry[];
    }): Promise<{
        result: boolean;
        departureTime: Date | null;
    }> {
        if (!this.busId) {
            return { result: false, departureTime: null };
        }
        const { summary } = params.customData as { summary: BusSummary[] };
        const seats = summary.map((seat, index) => ({
            status: seat.status as unknown as SeatStatus,
            number: seat.numbers[this.busId],
            passengerNationalCode: params.pax[index].nationalCode,
        }));
        const { data } = await ReserveSeatApiApiReserveSeatV2Post({
            reserveSeatParamsV2Dto: {
                billID: params.billId,
                email: params.email,
                passengers: params.pax.map(p => ({
                    firstName: p.persianFirstName,
                    lastName: p.persianLastName,
                    male: p.gender === Gender.Male,
                    nationalCode: p.nationalCode,
                    birthDate: p.birthDate,
                })),
                mobile: params.mobile,
                phone: '',
                seats,
                reserveID: this.reserveId,
                busID: this.busId,
            },
        });

        return {
            result: !!data.result,
            departureTime: dayConfig
                .gregory(data.departureTime?.substring(0, 19))
                .toDate(),
        };
    }

    /**
     * Returns the title of passenger, according to the given gender and passenger type
     */
    override getTitle(_type: PaxType, gender: Gender): string {
        return genderTitles[gender];
    }

    override prepayReservation(_billCode: string): Promise<void> {
        return Promise.resolve();
    }
}
